var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 32,
    viewBox: "0 0 58 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7153 0C49.4218 0.000227979 54.3392 4.01906 55.4751 9.61133L57.6714 20.4248C58.8863 26.4063 54.3141 32 48.2104 32C45.5386 31.9999 42.9859 30.8926 41.1606 28.9414L38.2856 25.8672C33.5433 20.798 25.5017 20.7981 20.7593 25.8672L18.1265 28.6826C16.1465 30.7991 13.3773 32 10.479 32C3.35236 31.9999 -1.6921 25.0351 0.529785 18.2637L3.81201 8.25879C5.42882 3.33137 10.0285 1.37584e-05 15.2144 0H43.7153ZM12.022 16C10.9176 16.0002 10.022 16.8956 10.022 18C10.022 19.1044 10.9176 19.9998 12.022 20C13.1265 20 14.022 19.1046 14.022 18C14.022 16.8954 13.1265 16 12.022 16ZM46.522 9C45.6937 9.00023 45.022 9.67171 45.022 10.5V12.5H43.022C42.1937 12.5002 41.522 13.1717 41.522 14C41.522 14.8283 42.1937 15.4998 43.022 15.5H45.022V17.5C45.022 18.3283 45.6937 18.9998 46.522 19C47.3504 19 48.022 18.3284 48.022 17.5V15.5H50.022C50.8504 15.5 51.522 14.8284 51.522 14C51.522 13.1716 50.8504 12.5 50.022 12.5H48.022V10.5C48.022 9.67157 47.3504 9 46.522 9ZM8.02197 12C6.9176 12.0002 6.02197 12.8956 6.02197 14C6.02197 15.1044 6.9176 15.9998 8.02197 16C9.12654 16 10.022 15.1046 10.022 14C10.022 12.8954 9.12654 12 8.02197 12ZM16.022 12C14.9176 12.0002 14.022 12.8956 14.022 14C14.022 15.1044 14.9176 15.9998 16.022 16C17.1265 16 18.022 15.1046 18.022 14C18.022 12.8954 17.1265 12 16.022 12ZM12.022 8C10.9176 8.00023 10.022 8.89557 10.022 10C10.022 11.1044 10.9176 11.9998 12.022 12C13.1265 12 14.022 11.1046 14.022 10C14.022 8.89543 13.1265 8 12.022 8Z",
    fill: "url(#paint0_linear_2149_9856)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2149_9856",
    x1: 28.934,
    y1: 0,
    x2: 28.934,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.389db75c96f4cbdeca00a341cc25abdd.svg";
export { ForwardRef as ReactComponent };